export default __webpack_public_path__ + "static/media/grading-confusion-matrix-status-en.a0a7ed4b.png";